import { Converter } from '../types/converter';

export const permeabilityConverter: Converter = {
  id: 'permeability',
  name: 'Permeability Converter',
  icon: 'Filter',
  categories: ['engineering'],
  units: [
    // Base unit
    { name: 'Kilogram/pascal/second/square meter', symbol: 'kg/Pa·s·m²', factor: 1 },
    
    // Temperature-specific units
    { name: 'Permeability at 0°C', symbol: 'μm²/Pa·s (0°C)', factor: 1e-12 },
    { name: 'Permeability at 23°C', symbol: 'μm²/Pa·s (23°C)', factor: 1.0889e-12 },
    { name: 'Permeability inches at 0°C', symbol: 'μin²/Pa·s (0°C)', factor: 6.4516e-16 },
    { name: 'Permeability inches at 23°C', symbol: 'μin²/Pa·s (23°C)', factor: 7.0251e-16 }
  ]
};
